import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Artesania } from "@/components/Artesania";
import { Productos } from "@/components/Productos";
import { Encargos } from "@/components/Encargos";
import { Calidad } from "@/components/Calidad";
import { Resenas } from "@/components/Resenas";
import { CtaBanner } from "@/components/CtaBanner";
import { Ubicacion } from "@/components/Ubicacion";

export default function Home() {
  return (
    <main>
      <Hero />
      <Marquee />
      <Artesania />
      <Productos />
      <Encargos />
      <Calidad />
      <Resenas />
      <CtaBanner />
      <Ubicacion />
    </main>
  );
}
